module.exports = __webpack_public_path__ + "static/btn_016.158500bb.png";